export const menuItems = [
  { label: "Dashboard", url: "/dashboard", inEnd: false, icon: "MdDashboard" },
  { label: "PDVs", url: "/pdvs", inEnd: false, icon: "MdOutlinePointOfSale" },
  { label: "Evento", url: "/evento", inEnd: false, icon: "MdEvent" },
  { label: "Produtos", url: "/produtos", inEnd: false, icon: "IoMdCart" },
  { label: "Grupos", url: "/grupos", inEnd: false, icon: "FaUserGroup" },
  {
    label: "Cardápios",
    url: "/cardapios",
    inEnd: false,
    icon: "MdOutlineRestaurantMenu",
  },
  { label: "Relatórios", url: "/relatorios", inEnd: false, icon: "TbReport" },
  {
    label: "Sair",
    action: "logoff",
    inEnd: true,
    icon: "IoLogOut",
  },
];

export const cores = [
  {
    label: "Azul Escuro",
    value: "#4682B4",
    api: "azulEscuro",
  },
  {
    label: "Azul Claro",
    value: "#43AAFF",
    api: "azulClaro",
  },
  {
    label: "Amarelo",
    value: "#C4CC22",
    api: "amarelo",
  },
  {
    label: "Vermelho",
    value: "#FF635D",
    api: "vermelho",
  },
  {
    label: "Laranja",
    value: "#FFBE83",
    api: "laranja",
  },
  {
    label: "Verde",
    value: "#1E7E49",
    api: "verde",
  },
  {
    label: "Roxo",
    value: "#666799",
    api: "roxo",
  },
  {
    label: "Marrom",
    value: "#CC5A22",
    api: "marrom",
  },
];

export const itemsList = [
  { index: 1, label: "Chopp", value: "/icone/01.png", api: "chopp" },
  { index: 2, label: "Lata", value: "/icone/02.png", api: "lataCerveja" },
  {
    index: 3,
    label: "Garrafa de Água",
    value: "/icone/03.png",
    api: "garrafaAgua",
  },
  {
    index: 4,
    label: "Garrafa de Cerveja",
    value: "/icone/04.png",
    api: "garrafaCerveja",
  },
  {
    index: 5,
    label: "Combo de Cerveja",
    value: "/icone/05.png",
    api: "comboCerveja",
  },
  {
    index: 6,
    label: "Cachorro Quente",
    value: "/icone/06.png",
    api: "cachorroQuente",
  },
  { index: 7, label: "Espetinho", value: "/icone/07.png", api: "espeto" },
  {
    index: 8,
    label: "Frango Assado",
    value: "/icone/08.png",
    api: "frangoAssado",
  },
  { index: 9, label: "Pizza", value: "/icone/09.png", api: "pizza" },
  {
    index: 10,
    label: "Cone de Sorvete",
    value: "/icone/10.png",
    api: "coneSorvete",
  },
  { index: 11, label: "Drink", value: "/icone/11.png", api: "drink" },
  { index: 12, label: "Batata Frita", value: "/icone/12.png", api: "batata" },
  { index: 13, label: "Caneca", value: "/icone/13.png", api: "caneca" },
  {
    index: 14,
    label: "Taça de Sorvete",
    value: "/icone/14.png",
    api: "tacaSorvete",
  },
  { index: 15, label: "Suco", value: "/icone/15.png", api: "suco" },
  { index: 16, label: "Tigela", value: "/icone/16.png", api: "tigela" },
  { index: 17, label: "Macarrão", value: "/icone/17.png", api: "macarrao" },
  { index: 18, label: "Pastel", value: "/icone/18.png", api: "pastel" },
  { index: 19, label: "Doce", value: "/icone/19.png", api: "doce" },
  { index: 20, label: "Lanche", value: "/icone/20.png", api: "lanche" },
  { index: 21, label: "Pão", value: "/icone/21.png", api: "pao" },
  { index: 22, label: "Taça", value: "/icone/22.png", api: "tacaVinho" },
  {
    index: 23,
    label: "Garrafa de Vinho",
    value: "/icone/23.png",
    api: "garrafaVinho",
  },
  { index: 24, label: "Ficha", value: "/icone/24.png", api: "ficha" },
  { index: 25, label: "Cartão", value: "/icone/25.png", api: "cartao" },
  { index: 26, label: "Valor", value: "/icone/26.png", api: "valor" },
  { index: 27, label: "Picolé", value: "/icone/27.png", api: "picole" },
  { index: 28, label: "Hambúrguer", value: "/icone/28.png", api: "hamburguer" },
  {
    index: 29,
    label: "Coxa de Frango",
    value: "/icone/29.png",
    api: "coxaFrango",
  },
  { index: 30, label: "Refeição", value: "/icone/30.png", api: "refeicao" },
  { index: 31, label: "Brinquedo", value: "/icone/31.png", api: "brinquedo" },
  { index: 32, label: "Oriental", value: "/icone/32.png", api: "oriental" },
  { index: 33, label: "Café", value: "/icone/33.png", api: "cafe" },
];

export const modosOperacao = [
  { label: "Normal | Fichas", value: 0, icon: "NormalFichas" },
  {
    label: "RFID Crédito",
    value: 1,
    icon: "RFIDCredito",
  },
  {
    label: "RFID Débito",
    value: 2,
    icon: "RFIDDebito",
  },
  {
    label: "RFID Débito e Crédito",
    value: 3,
    icon: "RFIDDebitoCredito",
  },
];

export const funcoesBotaoImprimir = [
  { label: "Imprimir Fichas", value: "0" },
  { label: "Imprimir Recibo", value: "1" },
  { label: "Imprimir Ficha e Recibo", value: "2" },
  { label: "RFID Débito Extrato", value: "3" },
  { label: "RFID Débito Ficha", value: "4" },
  { label: "RFID Débito Recibo", value: "5" },
  {
    label: "RFID Débito Extrato e Ficha",
    value: "6",
  },
  {
    label: "RFID Débito Extrato e Recibo",
    value: "7",
  },
  { label: "RFID Débito Sem Impressão", value: "8" },
  { label: "RFID Crédito Extrato", value: "9" },
  {
    label: "RFID Crédito Sem Impressão",
    value: "10",
  },
];

export const headersValid = [
  "descricao",
  "vlrUni",
  "unidade",
  "cor",
  "imagem",
  "ativo",
  "codGrupo",
  "descGrupo",
  "comissaoValor",
  "comissaoPorc",
  "vendaPeso",
];
